import useFetch from './useFetch';
import usePush from './usePush';
import AccountService from '../services/account-service';
import useShortCode from './useShortCode';

const NOTIFICATION_TYPES = {
  INVOICES_HISTORY_REMINDERS: 'invoice_history_reminders',
  INVOICES_HISTORY_MENTIONS: 'invoice_history_mentions',
  INVOICES_THRESHOLD: 'invoice_thresholds',
  CSV_FAILURE: 'csv_failure',
  PORTAL_PAYMENT_SUCCESS: 'portal_payment_success',
  EARLY_DISCOUNT_FEES: 'early_discount_fees',
  LATE_PAYMENT_FEES: 'late_payment_fees',
};

function useNotifications(notificationType) {
  const shortCode = useShortCode();
  const { data, applyOptimisticUpdate, upsert } = useFetch(AccountService.getNotificationSettings);
  const { execute: executeUpdateSetting } = usePush(AccountService.updateNotificationSetting);
  const { execute: executeUpdateAll } = usePush(AccountService.updateAllNotificationSettings);

  const notifications = data?.notificationsSettings?.find(
    item => item.organisation.ShortCode === shortCode,
  );

  const notification = notifications?.configuration.find(item => item.type === notificationType)
    ?.email;

  const upsertNotification = ({ enabled, NOTIFICATION_TYPE = notificationType }) =>
    upsert(state => {
      const item = state.notificationsSettings.find(i => i.organisation.ShortCode === shortCode);
      const notification = item.configuration.find(i => i.type === NOTIFICATION_TYPE);
      notification.email = enabled;
      return state;
    });

  return {
    data,
    notifications,
    notification,
    applyOptimisticUpdate,
    executeUpdateSetting,
    executeUpdateAll,
    upsertNotification,
  };
}

export default useNotifications;
export { NOTIFICATION_TYPES };
